module.exports = __webpack_public_path__ + "media/MRI7.a6642b2e.mp3";